import React from "react";
import FinalGrid from "../shared/FinalGrid";
import {useTranslation} from "react-i18next";

function Page5({ sim, setSim, getResult, goToQuestion }) {
    const res = getResult()
    const { t, i18n } = useTranslation();
    return (
        <div className="exam-sim-page-12">
            <div style={{ textAlign: 'center'}}>
                <h1 style={{marginBottom: 0}}>{t('sim.page5.title')}</h1>
                <div>
                    {t('sim.page5.text1')}
                </div>
            </div>
            <div className="exam-sim-result-list">
                <div className="exam-sim-row row-3">
                    <div className="exam-sim-col">
                        <div className={(res.result ? 'passed' : 'failed') + ' item'}>
                            <div>
                                <h3>{t('sim.page5.result')}</h3>
                                <div>{t('sim.page5.questionCount', { completed: res.correct, count: res.total })}</div>
                                {!res.result && <span>{t('sim.page5.required', { count: res.min - res.correct })}</span>}
                            </div>
                        </div>
                        <FinalGrid questions={sim.currentQuestions} step={2} goToQuestion={goToQuestion} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Page5;
